import DataManager from "./DataManager";

/**
 * PIXI.Application共通化クラス
 */
class MyApplication {
  // ---------------------------------------------------------------------------------------------------------
  // --	MyApplication
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  // eslint-disable-next-line no-useless-constructor
  constructor() {}

  /**
   * PIXI.Applicationの参照を取得
   */
  getMyApp() {
    if (!this.app) {
      //アプリケーション生成
      this.app = new PIXI.Application({
        resolution: 1,
        antialias: true,
        transparent: true,
      });

      //FPSの最大値を設定
      this.app.ticker.maxFPS = 60;

      //zIndexで重ね順を変更できるようにする
      this.app.stage.sortableChildren = true;

      //エミッター
      this.app.emitter = new PIXI.utils.EventEmitter();

      //DOMを配置
      document.getElementById("canvas-container").appendChild(this.app.view);

      //サイズ
      this.app.renderer.resize(564, 540);

      //データマネージャーで保持
      DataManager.setData("app", this.app);
    }

    return this.app;
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default new MyApplication();
